import React, { useEffect, useState } from 'react';

import { getInputClass } from '../../../utils/FormUtils';

interface TextInputProps {
    useConditionedStyling?: boolean;
    required?: boolean;
    valid?: boolean;
    isValidCallback?: (valid: boolean) => void;
    onChange?: (value: string) => void;
    onFocusChange?: () => void;
    value?: string;
    errorMessage?: React.ReactNode;
    label: React.ReactNode;
    helpText?: React.ReactNode;
    autoFocus?: boolean;
    disabled?: boolean;
    submitted: boolean;
    id?: string;
    placeholder?: string;
    isNumber?: boolean;
    isTime?: boolean;
}

export default function TextInput(props: TextInputProps) {
    const [touched, changeTouched] = useState<boolean>(false);
    const [valid, changeValid] = useState<boolean>(false);

    const isValid = (): boolean => {
        let check = true;
        if (check === true && props.required === true && (props.value === '' || props.value === undefined)) check = false;
        if (props.valid !== undefined && check === true) check = props.valid;
        if (props.isNumber && props.value) {
            const regex = /^-?\d+(\.\d+)?$/;
            check = regex.test(props.value);
        }
        if (props.isTime && props.value) {
            const regex = /^(?:[0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;
            check = regex.test(props.value);
        }
        changeValid(check);
        return check;
    };

    useEffect(() => {
        if (props.isValidCallback) {
            props.isValidCallback(isValid());
        } else isValid();
    }, [props.value, props.valid, props.required]);

    useEffect(() => {
        if (props.submitted) {
            !touched && changeTouched(true);
        }
    }, [props.submitted]);

    return (
        <>
            <div className='form-group'>
                <label>
                    {props.required ? <span className='text-danger me-1'>&#9679;</span> : <></>}
                    {props.label}
                </label>
                <input
                    className={props.useConditionedStyling === false ? 'form-control' : getInputClass(touched, valid, props.value)}
                    autoFocus={props.autoFocus}
                    id={props.id}
                    value={props.value}
                    type='text'
                    placeholder={props.placeholder}
                    onFocus={() => {
                        changeTouched(true);
                        props.onFocusChange && props.onFocusChange();
                    }}
                    required={props.required}
                    onChange={(event) => {
                        if (props.onChange) props.onChange(event.target.value);
                        isValid();
                    }}
                    disabled={props.disabled}
                />
                {valid === false && touched === true ? (
                    <span className='badge bg-gradient-danger mt-2'>
                        <small>{props.errorMessage}</small>
                    </span>
                ) : (
                    <></>
                )}
            </div>
        </>
    );
}
